module.exports = __webpack_public_path__ + "img/2019-2.e1de1ec1.jpg";